module.exports = __webpack_public_path__ + "media/images/digivent/arrow_down-630f2bdd06dd5e12df669d0d66fda0d1.svg";